import React, { useState } from "react";

export default function CreateLiveStreamButton(props) {
  async function onStartStream(name) {
    console.log("here, name: ", name);
    let body = {
      name: name,
      profiles: [
        {
          name: "720p",
          bitrate: 2000000,
          fps: 30,
          width: 1280,
          height: 720,
        },
        {
          name: "480p",
          bitrate: 1000000,
          fps: 30,
          width: 854,
          height: 480,
        },
        {
          name: "360p",
          bitrate: 500000,
          fps: 30,
          width: 640,
          height: 360,
        },
      ],
    };

    // TODO add Livepeer AWS switching logic for create stream
    let id;
    if(true) {
      let data = await fetch(
        "https://73vw7wmlk1.execute-api.us-west-2.amazonaws.com/dev/create_aws_stream",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        }
      ).then((res) => res.json());
      id = data.id;
    } else {
      let data = await fetch(
        "https://73vw7wmlk1.execute-api.us-west-2.amazonaws.com/dev/createStream",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        }
      ).then((res) => res.json());
      id = data.id;
    }

    // window.location.href = `${window.location.origin}/display-stream-details/${id}`;
    window.open(
      `${window.location.origin}/display-stream-details/${id}`,
      "_blank"
    );
  }

  return (
    <div
      onClick={() => onStartStream(props.streamName)}
      className={
        props.isForStreamerProfile
          ?
        "bg-custom-black dark:bg-gray-200 h-8 w-24 sm:w-28 mt-4 ml-12 font-semibold justify-center items-center rounded-lg flex font-medium text-white dark:text-black cursor-pointer"
          :
        props.isForCreatorDashboard
          ?
        "mt-8 bg-blue-600 text-white font-semibold cursor-pointer hover:bg-blue-500 h-10 w-40 flex justify-center items-center rounded-lg"
          :
        "bg-custom-black dark:bg-gray-200 h-12 w-48 mb-4 font-semibold justify-center items-center rounded-lg flex font-medium text-white dark:text-black cursor-pointer"
      }
    >
      Stream Info
    </div>
  );
}
